module.exports = __webpack_public_path__ + "static/media/readMessage.dc9f7edd.svg";